import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './StickyMobileCta.css';

// Floating "Get a Quote" CTA pinned to the bottom of mobile screens.
// Appears after the user scrolls past the hero (250px). Hidden on
// desktop (handled by CSS @media). Hidden on the /quote and /admin
// pages where the CTA would be redundant or intrusive.
export default function StickyMobileCta() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    function onScroll() {
      setShow(window.scrollY > 250);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (pathname.startsWith('/quote') || pathname.startsWith('/admin') || pathname.startsWith('/manage')) return null;

  return (
    <Link
      to="/quote"
      className={`sticky-mobile-cta${show ? ' is-visible' : ''}`}
      aria-label="Request a Quote"
    >
      Get a Quote
    </Link>
  );
}
